import { useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { api } from "../lib/api";

const LINKS = [
  { to: "/admin/operations", label: "Requests" },
  { to: "/intake", label: "Check-In" },
  { to: "/tickets", label: "Tickets" },
  { to: "/admin/blog", label: "Blog" },
  { to: "/admin/analytics", label: "Traffic" },
  { to: "/admin/content", label: "Content" },
  { to: "/admin/notifications", label: "Notifications" },
  { to: "/assistant-settings", label: "Assistant" },
];

export default function StaffShell({ children, title }) {
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    api("/staff/me").catch(() => nav("/staff/login"));
  }, [nav, loc.pathname]);

  const logout = async () => {
    await api("/staff/logout", { method: "POST" }).catch(() => {});
    nav("/staff/login");
  };

  return (
    <div data-testid="staff-shell">
      <nav className="staff-nav" data-testid="staff-nav">
        <strong style={{ fontFamily: "var(--font-display)", marginRight: 10 }}>
          <span style={{ color: "var(--red-bright)" }}>C.C.C.</span> <span style={{ color: "var(--blue-bright)" }}>Shop Tools</span>
        </strong>
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? "active" : "")} data-testid={`staff-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}>
            {l.label}
          </NavLink>
        ))}
        <Link to="/" style={{ marginLeft: "auto" }}>View site</Link>
        <button className="btn btn-ghost btn-sm" onClick={logout} data-testid="staff-logout-button"><LogOut size={13} /> Sign out</button>
      </nav>
      <div className="container staff-wrap">
        <div className="panel-title">
          <h1>{title}</h1>
        </div>
        {children}
      </div>
    </div>
  );
}
